import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { sportIds } from 'src/constants'
import { leagueGroupIds } from 'src/constants/personalizationIds'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
import { subtitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      // video={'https://assets.fubo.tv/marketing/lp/videos/compressed/CA_ArsenalFanOrg_LP_9s.mp4'}
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/EPL/EPL_Arsenal_Hero_Desktop.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/EPL/EPL_Arsenal_Hero_Mobile.jpg"
      title="Watch Arsenal soccer live"
      subtitle={subtitleText.epl}
      networkSet="canada_sports"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
      logoHeight="90px"
      team="Arsenal"
      // hasScheduleBanner={true}
      planCardsConfig={{
        plans: canadaPlanSet.sports,
        overrides: {
          ...canadaSports_EPL_UCL_Override,
          // sports: {
          //   all: {
          //     promoImg:
          //       'https://assets-imgx.fubo.tv/marketing/lp/images/card/ca_card_soccer-arsenal.jpg?w=451&ch=width&auto=format,compress',
          //   },
          // },
        },
      }}
      matchtickerSportId={sportIds.Soccer}
      matchtickerLeagueName="Multiple Sports"
      matchtickerLeagueId={leagueGroupIds.canada_soccer}
    />
  )
}
